"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var flatten = function flatten(source) {
  return function (start, sink) {
    if (start !== 0) return;

    var exists = function exists(x) {
      return typeof x !== 'undefined';
    };

    var absent = function absent(x) {
      return typeof x === 'undefined';
    };

    var outerEnded = false;
    var outerTalkback;
    var innerTalkback;

    function talkback(t, d) {
      if (t === 1) (innerTalkback || outerTalkback)(1, d);

      if (t === 2) {
        innerTalkback && innerTalkback(2);
        outerTalkback && outerTalkback(2);
      }
    }

    source(0, function (T, D) {
      if (T === 0) {
        outerTalkback = D;
        sink(0, talkback);
      } else if (T === 1) {
        var innerSource = D;
        if (innerTalkback) innerTalkback(2);
        innerSource(0, function (t, d) {
          if (t === 0) {
            innerTalkback = d;
            innerTalkback(1);
          } else if (t === 1) sink(1, d);else if (t === 2 && absent(d)) {
            if (outerEnded) sink(2);else {
              innerTalkback = void 0;
              outerTalkback(1);
            }
          } else if (t === 2 && exists(d)) sink(2, d);
        });
      } else if (T === 2 && absent(D)) {
        if (!innerTalkback) sink(2);else outerEnded = true;
      } else if (T === 2 && exists(D)) sink(2, D);
    });
  };
};

var _default = flatten;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/callbag-flatten/index.js
// module id = 631
// module chunks = 0